module.exports = __webpack_public_path__ + "static/background_mobile.45e4bed4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Speakers/Background/background_mobile.jpg
// module id = 714
// module chunks = 213534597649335